import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Link as MuiLink,
  IconButton
} from '@mui/material';
import FileInput from "../Shared/FileUploadPreview/FileInput";
import { useSnackBar } from "../FlowBuilder/Common/SnackBar/index.tsx";
import DynamicBreadcrumbs from "../Shared/Breadcrumb/index.tsx";
import HomeIcon from '@mui/icons-material/Home';
import { useNavigate } from "react-router";

const MAX_VIDEO_SIZE = 20 * 1024 * 1024; // 20 MB

const Videotoolsping = () => {
  const [file, setFile] = useState<File | null>(null);
  const [url, setUrl] = useState<string>('');
  const { showSnackBar } = useSnackBar();
  const navigate = useNavigate();

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files?.[0];
    if (!selectedFile) return;

    if (selectedFile.type !== 'video/mp4') {
      showSnackBar("Only MP4 video files are allowed.", "error");
      return;
    }

    if (selectedFile.size > MAX_VIDEO_SIZE) {
      showSnackBar("Video files must be smaller than 20 MB.", "error");
      return;
    }

    setFile(selectedFile);
  };

  const handleUpload = async () => {
    if (!file) {
      showSnackBar("Please select a video file to upload.", "error");
      return;
    }

    const my_filename = `${Date.now().toString()}${file.name}`.replace(/ /g, '_');
    const updatedFile = new File([file], my_filename, { type: file.type });

  };
  const breadcrumbsData = [
    {
      label: <IconButton color="primary"><HomeIcon /></IconButton>,
      onClick: () => navigate('/')
    },
    { label: "Tools", onClick: () => navigate('/r/tools') },
    { label: 'Video Scraping' }
  ]
  return (
    <Box sx={{ backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
      <DynamicBreadcrumbs
        items={breadcrumbsData}
        onBreadcrumbClick={(e, item) => item?.onClick?.()}
      />
      <div className="p-4">
        {/* <Typography variant="h4">Video toolsping Page</Typography> */}
        <Grid fluid className="d-flex vh-50 style-file-upload">
          <Grid container justifyContent="center">
            <Grid xs={12} md={6} sx={{justifyItems:'center'}}>
              <Card elevation={3} sx={{width:"40%"}}>
                <CardContent sx={{paddingTop:"18px" , justifyItems:'center'}}>
                  <Typography variant="h6" gutterBottom>
                    Upload a Video File
                  </Typography>

                  <Box mt={2}>
                    <FileInput
                      onFileSelect={handleFileChange}
                      onFileRemove={() => setFile(null)}
                      onFileUpload={handleUpload}
                      file={file}
                      accept="video/mp4"
                    />
                  </Box>

                  {url && (
                    <Box mt={3}>
                      <Typography variant="body2" color="success.main">
                        Video uploaded successfully!
                      </Typography>
                      <Box mt={1}>
                        <MuiLink
                          component="button"
                          variant="body2"
                          onClick={() => navigator.clipboard.writeText(url)}
                          sx={{ mr: 2 }}
                        >
                          Copy URL
                        </MuiLink>
                        <MuiLink href={url} target="_blank" rel="noopener">
                          Open Uploaded Video
                        </MuiLink>
                      </Box>
                    </Box>
                  )}
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </Box>
  );
};

export default Videotoolsping;
